


document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.js-ebs-toggle-password');

  toggles.forEach(function (toggle) {
    const targetSelector = toggle.getAttribute('data-target');
    let input = null;

    // --- CERCA L’INPUT USANDO IL SELECTOR DI data-target ---
    if (targetSelector) {
      input = document.querySelector(targetSelector);
    }

    // --- FALLBACK: cerca input vicino ---
    if (!input) {
      const container = toggle.closest('.form-floating, .input-group, .position-relative') || toggle.parentElement;
      if (container) {
        input = container.querySelector('input[type="password"], input[type="text"]');
      }
    }

    if (!input) return;

    // Stato iniziale
    input.type = 'password';
    toggle.setAttribute('data-ebs-password-visible', 'false');

    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      const isVisible = toggle.getAttribute('data-ebs-password-visible') === 'true';

      // Mostra/nascondi
      input.type = isVisible ? 'password' : 'text';

      // Aggiorna attributo stato sul button
      toggle.setAttribute('data-ebs-password-visible', isVisible ? 'false' : 'true');

      // Accessibilità
      toggle.setAttribute('aria-label', isVisible ? 'Mostra password' : 'Nascondi password');
      toggle.setAttribute('aria-pressed', isVisible ? 'false' : 'true');
    });
  });
});